import { render, staticRenderFns } from "./FormUserRolePermissionSetting.vue?vue&type=template&id=276dde5f&scoped=true&"
import script from "./FormUserRolePermissionSetting.vue?vue&type=script&lang=js&"
export * from "./FormUserRolePermissionSetting.vue?vue&type=script&lang=js&"
import style0 from "./FormUserRolePermissionSetting.vue?vue&type=style&index=0&id=276dde5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276dde5f",
  null
  
)

export default component.exports